import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoodBadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mood_bad"}/>
}
